<template>
  <div class="AnalysisName">
    <div id="form-div">
      <div class="row justify-content-center align-items-center px-3">
        <div class="col-md-10">
          {{ $t('wheelAnalysis.analysisName.selectNamePrompt') }}
        </div>

        <div class="col-md-10">
          <input
              :disabled="!editMode"
              :label="$t('wheelAnalysis.analysisName.inputLabel')"
              v-model="name"
              @blur="challengeStore.nameChanged()"
              :placeholder="$t('wheelAnalysis.analysisName.inputPlaceholder')"
          />
        </div>
      </div>

      <div class="sidebar-instructions p-4">
        {{ $t('wheelAnalysis.analysisName.returnLaterNote') }}
      </div>
    </div>
  </div>

  <router-view />
</template>

<script src="./_AnalysisName.js" lang="js"></script>
<style src="./_AnalysisName.less" lang="less" scoped></style>
